import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import Button from "@material-ui/core/Button";
import moment from "moment";
import { DatePicker } from "@material-ui/pickers/DatePicker";

export const SalesRepressentative = (props) => {
  const [salesRep, setSalesRep] = useState(props.currentRepresentative);
  const [changeDate, setChangeDate] = useState(moment(new Date()));

  return (
    <div>
      <p>
        Select sales representative, set to none to clear sales representative
        and organization
      </p>
      <TextField
        size="small"
        variant="outlined"
        select
        label="Sales representative"
        onChange={(e) => setSalesRep(e.target.value)}
        menuItemStyle={{ color: "#000000" }}
        value={salesRep}
        style={{ marginRight: "1rem" }}
      >
        <MenuItem value={null}>None</MenuItem>
        {props.representatives.map((item) => {
          return (
            <MenuItem key={item.Id} value={item.Id}>
              {item.DisplayName}
            </MenuItem>
          );
        })}
      </TextField>
      <DatePicker
        inputVariant="outlined"
        className="small-datepicker-no-margin"
        label="Change date swedish time"
        onChange={setChangeDate}
        value={changeDate}
        style={{ margin: "0 1rem 0 0" }}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => props.setRepresentative(salesRep, changeDate)}
      >
        Set Sales representative
      </Button>
    </div>
  );
};
